module.exports = __webpack_public_path__ + "img/shield.4b0c5844.svg";